export interface StageRibbonStep {
  label: string;
}

export interface StageRibbonProps {
  stages: StageRibbonStep[];
  /** Zero-based index of the currently-active stage. */
  currentIndex: number;
}

/**
 * Primitive 5: Stage Ribbon — chevron progress indicator.
 *
 * Bill 2026-05-11 (Continue / Return navigation convention) — the in-ribbon
 * "Mark Stage Complete" button was removed bank-wide. Stage advancement is
 * driven by the sticky-footer `[← Back] / [Continue →]` dyad on the cart
 * shell + modal wizards. The ribbon is now a pure visual progress indicator.
 */
export function StageRibbon({ stages, currentIndex }: StageRibbonProps): JSX.Element {
  return (
    <div className="stage-ribbon-wrap">
      <div className="stage-ribbon" role="list">
        {stages.map((stage, i) => {
          const isDone = i < currentIndex;
          const isActive = i === currentIndex;
          return (
            <div
              key={stage.label}
              role="listitem"
              className={`stage ${isDone ? 'is-done' : ''} ${isActive ? 'is-active' : ''}`.trim()}
              aria-current={isActive ? 'step' : undefined}
            >
              <span className="stage__num">{isDone ? '✓' : i + 1}</span>
              <span>{stage.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
